// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer--cell--2b_tdjPH {\n  min-height: 40px;\n  min-width: 60px;\n  padding: 8px;\n  border: 1px solid #0592af;\n  box-sizing: border-box;\n}\n.answer--multChoiceSummary--3wj_7cY1 {\n  text-align: center;\n  font-weight: 100;\n  flex: 1;\n  min-width: 100px;\n}\n.answer--nowrap--2MxdoTcB {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.answer--clickable--23Ktuack {\n  cursor: pointer;\n  font-weight: 500;\n}\n.answer--genericAnswer--2ts2DZNS {\n  text-align: center;\n  color: #999;\n}\n", ""]);
// Exports
exports.locals = {
	"cell": "answer--cell--2b_tdjPH",
	"multChoiceSummary": "answer--multChoiceSummary--3wj_7cY1",
	"nowrap": "answer--nowrap--2MxdoTcB",
	"clickable": "answer--clickable--23Ktuack",
	"genericAnswer": "answer--genericAnswer--2ts2DZNS"
};
module.exports = exports;
